export const backendUrlImages = "https://eventscons.com/eventbackendnew/storage/app/public/"
